module.exports = __webpack_public_path__ + "img/wine-bottle.8a9814f4.svg";